import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { Draggable, Droppable } from "react-beautiful-dnd";
import List from "@material-ui/core/List";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ModifierarticleDraggable from "./ModifierarticleDraggable";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditTextField from "../../EditArticle/EditTextField";
import { updateModifiergroups, updateModifiergroupsTranslations } from "../../../store/articles/ModifiergroupsApi";
import withIntl from "../../../utils/withIntl";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import cloudStore from "../../../store/CloudStore";
import { useDialog } from "../../Dialogs/DialogProvider";
import { getTranslationValue } from "../../../store/articles/ArticlesHelpers";
import LinkedItems from "../LinkedItems";
import ActionButtonModifiergroup from "../ActionButtons/ActionButtonModifiergroup";
import Chip from "@material-ui/core/Chip";
import SelectArticlesDialog from "../../Dialogs/SelectArticlesDialog";
import EditSwitch from "../../EditArticle/EditSwitch";
import EditNumberField from "../../EditArticle/EditNumberField";
import { Grid, Typography } from "@material-ui/core";
import { updateArticle } from "../../../store/articles/ArticlesApi";
import { updateModifierarticles } from "../../../store/articles/ModifierarticlesApi";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    display: "block",
  },
  rootButton: {
    fontSize: 12,
    padding: 2,
    margin: 12,
  },
  rootChip: { fontSize: 10, padding: 1 },
  sizeSmall: { height: 16 },
}));

function ModifiergroupDraggable(props) {
  const classes = useStyles();
  const [expandedModifierarticles, setExpandedModifierarticles] = React.useState([]);
  const [openDialog] = useDialog();

  const onModifierarticleExpand = (modifierarticle) => {
    if (!expandedModifierarticles.includes(modifierarticle.id)) {
      setExpandedModifierarticles([...expandedModifierarticles, modifierarticle.id]);
    } else {
      expandedModifierarticles.splice(
        expandedModifierarticles.findIndex((entry) => entry === modifierarticle.id),
        1
      );
      setExpandedModifierarticles([...expandedModifierarticles]);
    }
  };

  const updateTranslations = (value) => {
    const translationsObject =
      articlesStore.translations[props.modifiergroup.translation_id] === null
        ? {}
        : { ...articlesStore.translations[props.modifiergroup.translation_id] };
    return updateModifiergroupsTranslations(
      articlesStore.merchantId,
      [props.modifiergroup],
      [{ translation: { [props.currentLanguage]: value } }],
      translationsObject
    ).then(Promise.resolve());
  };

  let linkedArticles = [];
  props.modifiergroup.articleIds.forEach((articleId) =>
    linkedArticles.push({
      name: articlesStore.articles[articleId].name,
      link: `/home/${cloudStore.merchant.id}/articles/articles?searchValue=${articlesStore.articles[articleId].name}&articleId=${articleId}`,
      id: articleId,
    })
  );

  return (
    <div className={classes.root}>
      <Accordion
        aria-label="Expand"
        aria-controls="additional-actions1-content"
        id="additional-actions1-header"
        TransitionProps={{ unmountOnExit: true }}
        expanded={props.expandedModifiergroups.includes(props.modifiergroup.id)}
        defaultExpanded
        variant="outlined"
        innerRef={props.provided.innerRef}
        {...props.provided.draggableProps}
        onChange={() => props.handleExpansion(props.modifiergroup.id)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          {!props.hideDragHandles && (
            <AuthorizationWrapper
              permission={"_"}
              child={
                <div
                  {...props.provided.dragHandleProps}
                  style={{ cursor: "move", display: "flex", flexDirection: "column", justifyContent: "center" }}
                >
                  <DragHandleIcon
                    style={{
                      marginLeft: 0,
                      marginRight: 10,
                    }}
                  />
                </div>
              }
            />
          )}
          <div style={{ height: "auto", alignItems: "center" }}>
            <EditTextField
              authorizationField={
                "modifiergroup.name" +
                (props.currentLanguage === cloudStore.merchant.default_language ? "" : ".other_language")
              }
              label={props.intl.formatMessage({ id: "option_group_name" })}
              value={getTranslationValue("name", "translation_id", props.currentLanguage, props.modifiergroup, "")}
              placeholder={props.modifiergroup.name}
              onBlur={(newModifiergroupName, setBeginValue) => {
                if (props.currentLanguage === cloudStore.merchant.default_language) {
                  updateModifiergroups(
                    articlesStore.merchantId,
                    [props.modifiergroup],
                    [{ name: newModifiergroupName }]
                  ).then(() => {
                    setBeginValue(newModifiergroupName);
                  });
                } else {
                  updateTranslations(newModifiergroupName).then(() => setBeginValue(newModifiergroupName));
                }
              }}
              variant={"standard"}
            />
          </div>
          <div style={{ display: "flex" }}>
            <AuthorizationWrapper
              permission={"modifiergroup.plu"}
              child={
                <Chip
                  classes={{ root: classes.rootChip, sizeSmall: classes.sizeSmall }}
                  variant="outlined"
                  label={"PLU: " + props.modifiergroup.plu}
                  size="small"
                  color="primary"
                />
              }
            />
            <AuthorizationWrapper
              permission={"modifiergroup.id"}
              child={
                <Chip
                  classes={{ root: classes.rootChip, sizeSmall: classes.sizeSmall }}
                  variant="outlined"
                  label={"id: " + props.modifiergroup.id}
                  size="small"
                  color="primary"
                />
              }
            />
            <EditSwitch
              key={props.modifiergroup.key}
              authorizationField={"modifiergroup.manual_active"}
              value={!!props.modifiergroup.manual_active}
              onChange={(newValue, setBeginValue) => {
                updateModifiergroups(
                  articlesStore.merchantId,
                  [props.modifiergroup],
                  [{ manual_active: newValue }]
                ).then(() => setBeginValue(newValue));
              }}
            />
          </div>
          {props.expandedModifiergroups.some((modifiergroupId) => modifiergroupId === props.modifiergroup.id) && (
            <ActionButtonModifiergroup modifiergroup={props.modifiergroup} />
          )}
        </AccordionSummary>
        <AccordionDetails
          classes={{
            root: classes.root,
          }}
        >
          <Typography style={{ fontWeight: 800, marginRight: 10, marginTop: 20 }}>
            {props.intl.formatMessage({ id: "additional_settings" })}
          </Typography>
          <div style={{ display: "flex" }}>
            <EditSwitch
              label={props.intl.formatMessage({ id: "multiple" })}
              authorizationField={"modifiergroup.multiple"}
              value={props.modifiergroup.multiple}
              // onChange={(newValue) => (props.modifiergroup.multiple = newValue)}
              onChange={(newValue, setBeginValue) =>
                updateModifiergroups(articlesStore.merchantId, [props.modifiergroup], [{ multiple: newValue }]).then(
                  () => {
                    setBeginValue(newValue);
                  }
                )
              }
            />
            <EditSwitch
              label={props.intl.formatMessage({ id: "optional" })}
              authorizationField={"modifiergroup.optional"}
              value={props.modifiergroup.optional}
              onChange={(newValue, setBeginValue) =>
                updateModifiergroups(articlesStore.merchantId, [props.modifiergroup], [{ optional: newValue }]).then(
                  () => {
                    setBeginValue(newValue);
                  }
                )
              }
            />
            <EditSwitch
              label={props.intl.formatMessage({ id: "numerable" })}
              authorizationField={"modifiergroup.numerable"}
              value={props.modifiergroup.numerable}
              onChange={(newValue, setBeginValue) =>
                updateModifiergroups(articlesStore.merchantId, [props.modifiergroup], [{ numerable: newValue }]).then(
                  () => {
                    setBeginValue(newValue);
                  }
                )
              }
            />
            <EditSwitch
              label={"Do not print on bill"}
              authorizationField={"article.doNotPrintOnTotalReceipt"}
              value={props.modifiergroup.meta_json?.doNotPrintOnTotalReceipt ?? false}
              onChange={(newValue, setBeginValue) => {
                updateModifiergroups(
                  articlesStore.merchantId,
                  [props.modifiergroup],
                  [{ meta_json: { doNotPrintOnTotalReceipt: newValue } }]
                ).then(() => setBeginValue(newValue));
              }}
            />
            <div style={{ width: 200 }}>
              <EditTextField
                authorizationField={"modifiergroup.pos_name"}
                label={props.intl.formatMessage({ id: "batch.pos_name" })}
                value={props.modifiergroup.pos_name ?? ""}
                onBlur={(value, setBeginValue) => {
                  updateModifiergroups(articlesStore.merchantId, [props.modifiergroup], [{ pos_name: value }]).then(
                    () => {
                      setBeginValue(value);
                    }
                  );
                }}
                variant={"standard"}
              />
            </div>
            <div style={{ width: 200 }}>
              <EditNumberField
                variant={"standard"}
                authorizationField={"article.max_n"}
                label={"Max N"}
                value={props.modifiergroup.max_n == null ? "" : props.modifiergroup.max_n}
                onBlur={(newValue, setBeginValue) =>
                  updateModifiergroups(articlesStore.merchantId, [props.modifiergroup], [{ max_n: newValue }]).then(
                    () => {
                      setBeginValue(newValue);
                    }
                  )
                }
              />
            </div>
          </div>
          <LinkedItems
            authorizationPrefix={"modifiergroup"}
            title={props.intl.formatMessage({ id: "linked_articles" })}
            linkedItems={linkedArticles}
            onDelete={(articleId) => {
              let article = articlesStore.articles[articleId];
              let modifiergroupIds = [...article.modifiergroupIds];
              let index = modifiergroupIds.indexOf(props.modifiergroup.id);
              modifiergroupIds.splice(index, 1);
              return updateArticle(articlesStore.merchantId, article, { modifiergroupIds: modifiergroupIds });
            }}
            onAdd={() => {
              openDialog({
                children: (
                  <SelectArticlesDialog
                    multiple
                    handleAdd={(articleId) => {
                      let newArticle = articlesStore.articles[articleId];
                      let modifiergroupIds = newArticle.modifiergroupIds;
                      modifiergroupIds.push(props.modifiergroup.id);
                      return updateArticle(articlesStore.merchantId, newArticle, {
                        modifiergroupIds: modifiergroupIds,
                      });
                    }}
                    filteredOutArticles={props.modifiergroup.articleIds}
                  />
                ),
                fullWidth: true,
                maxWidth: "sm",
              });
            }}
          />
          <Droppable type="MODIFIERARTICLE" droppableId={"droppable-modifiergroup-" + props.modifiergroup.id}>
            {(provided) => {
              return (
                <List dense innerRef={provided.innerRef} {...provided.droppableProps}>
                  {props.modifiergroup
                    .getModifierarticles(articlesStore.modifierarticles)
                    .reduce((modifierarticles, modifierarticle, modifierarticleIndex) => {
                      if (modifierarticle.hide) {
                        return modifierarticles;
                      }
                      modifierarticles.push(
                        <Draggable
                          type="MODIFIERARTICLE"
                          draggableId={"draggable-modifierarticle-" + modifierarticle.id}
                          index={modifierarticleIndex}
                          key={props.currentLanguage + modifierarticle.id}
                          isDragDisabled={props.hideDragHandles}
                        >
                          {(provided, snapshot) => {
                            return (
                              <ModifierarticleDraggable
                                setSearchValue={props.setSearchValue}
                                modifiergroup={props.modifiergroup}
                                provided={provided}
                                snapshot={snapshot}
                                modifierarticleId={modifierarticle.id}
                                expanded={expandedModifierarticles.includes(modifierarticle.id)}
                                onExpand={onModifierarticleExpand}
                                hideDragHandles={props.hideDragHandles}
                                currentLanguage={props.currentLanguage}
                                setCurrentLanguage={props.setCurrentLanguage}
                              />
                            );
                          }}
                        </Draggable>
                      );
                      return modifierarticles;
                    }, [])}
                  {provided.placeholder}
                </List>
              );
            }}
          </Droppable>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default withIntl(ModifiergroupDraggable);
